import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { CompanyEntityIndex } from '@funnels/types';

import { PhoneInput } from '../../Common';

interface BusinessPhoneNumberProps extends CompanyEntityIndex {
  isOptional?: boolean;
  isDisabled?: boolean;
  isForeignCompany?: boolean;
}

export const BusinessPhoneNumber = (props: BusinessPhoneNumberProps) => {
  const { companyIndex, isForeignCompany = false, ...rest } = props;

  return (
    <PhoneInput
      {...rest}
      isInternational={isForeignCompany}
      name={FIELD_PATHS.COMPANY_PHONE_NUMBER(companyIndex)}
      className={PII_FIELD_MASKING_CLASS}
    />
  );
};
